import React from 'react';
import { Button } from '@blueprintjs/core';
import classnames from 'classnames';

export default class DataTable extends React.Component {

  render() {
    let pageNumber = this.props.pageData ? this.props.pageData.number : 0;
    let pageSize = this.props.pageData ? this.props.pageData.size : 0;
    let dataListItem = this.props.dataList.map((item, i) => {
      return (
      React.cloneElement(this.props.children, {
        key: i,
        count: (pageNumber * pageSize) + i + 1,
        item,
        parent: this.props.parent
      }))
    });

    let ItemLoading = (
    <div className="loading-content">
      <span className="shape1"></span>
      <span className="shape2"></span>
      <span className="shape3"></span>
      <span className="shape4"></span>
      <span className="shape5"></span>
      <span className="shape6"></span>
      <span className="shape7"></span>
      <span className="shape8"></span>
      <span className="shape9"></span>
      <span className="shape10"></span>
      <span className="shape11"></span>
      <span className="shape12"></span>
      <span className="shape13"></span>
    </div>
    )
    return (
      <div className='wrapper-table wrap-table wrap-theo-doi'>
        <div className="table-container">
          <table className="table-content">
            <thead className="table-header">
              {
                this.props.header.map((headerItems, i) => {
                  let items = [];
                  items = [...headerItems]
                  return (
                    <tr key={ i }>
                      {
                        items.map((item, j) => {
                          return (
                            <th key={ j } className={ "table-header-col " + (item.className ? item.className : '') } colSpan={ item.colSpan } rowSpan={ item.rowSpan } style={ { maxWidth: item.maxWidth, width: item.width, minWidth: item.minWidth } }>
                              { item.name }
                            </th>
                          );
                        })
                      }
                    </tr>
                  );
                })
              }
            </thead>
            { this.props.tableLoading ? (
              <tbody className="table-body">
                <tr className="table-loading">
                  <td colSpan={ this.props.numberColumnHeader }>
                    { ItemLoading }
                    { ItemLoading }
                    { ItemLoading }
                  </td>
                </tr>
              </tbody>
              ) : (
              <tbody className="table-body">
                { dataListItem }

                  { !this.props.dataList.length && !this.props.showAddMore? (this.props.search ?
                      (
                      <tr>
                        <td colSpan={ this.props.numberColumnHeader }>Không có dữ liệu</td>
                      </tr>
                      ) : (
                      <tr>
                        <td colSpan={ this.props.numberColumnHeader }>Chưa có dữ liệu</td>
                      </tr>
                    )) : null
                  }
                  {
                    this.props.dataList.length > 0 && !this.props.hiddenSum ? (
                      <tr className='bottom-value'>
                        <td colSpan={ 2 } className='txt-left'><span className='title-12'>Tổng đơn</span></td>
                        <td className='txt-center black-val'>{this.props.theoDoiDonDocTheoKy ? this.props.tongDonTrongKy : this.props.tongDonDungHanDangXL}</td>
                        <td
                          className={classnames('txt-center', {
                            "red-val": !this.props.theoDoiDonDocTheoKy,
                            "black-val": this.props.theoDoiDonDocTheoKy
                          })}
                        >
                          {this.props.theoDoiDonDocTheoKy ? this.props.tongDonKyTruoc : this.props.tongDonTreHanDangXL}
                        </td>
                        <td className='txt-center black-val'>{this.props.theoDoiDonDocTheoKy ? this.props.tongDon : this.props.tongDonDungHanDaXL}</td>
                        <td
                          className={classnames('txt-center', {
                            "red-val": !this.props.theoDoiDonDocTheoKy,
                            "black-val": this.props.theoDoiDonDocTheoKy
                          })}
                        >
                          {this.props.theoDoiDonDocTheoKy ? this.props.tongDonDangXLGQ : this.props.tongDonTreHanDaXL}
                        </td>
                        <td className='txt-center black-val'>{this.props.theoDoiDonDocTheoKy ? this.props.tongDonDaXLGQ : this.props.tongDonDangDaXL}</td>
                      </tr>
                    ) : null
                  }
              </tbody>
              ) }
          </table>
        </div>
        {
          this.props.ThongKeBaoCao ?
          ( <div className="pagination-wrap">
              <Button className={ this.state.export } text={ this.props.exporttext } onClick={ this.handleExport.bind(this) } />
            </div>)
          : ( <div></div> )
        }
      </div>
      );
  }
}
DataTable.defaultProps = {
  type: 'THUONG_XUYEN',
  labelPagination: 'Số hồ sơ',
  showAddMore: false,
  typeExport: 'TIEP_CONG_DAN',
  ThongKeBaoCao: false,
  header: []
}



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/datatable/DataTable.jsx